import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, retry, timer } from 'rxjs';

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
  private readonly maxRetries = 3;
  private readonly initialDelayMs = 1000;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method !== 'GET') {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      retry({
        count: this.maxRetries,
        delay: (error, retryCount) => {
          if (!this.isRetryable(error.status)) {
            throw error;
          }
          const delayMs = this.initialDelayMs * Math.pow(2, retryCount - 1);
          console.warn(`[RetryInterceptor] Retrying GET ${request.url} (attempt ${retryCount}/${this.maxRetries}, delay ${delayMs}ms)`);
          return timer(delayMs);
        },
      }),
    );
  }

  private isRetryable(status: number): boolean {
    return status === 0 || status >= 500;
  }
}
